<template>
<div>
<form v-on:submit.prevent="setVat()">    
<!--<label for="validationDefault03">IVA</label>-->
<div class="input-group">
<div class="input-group-prepend">
    <div class="input-group-text">% IVA</div>
</div>

<input required v-focus ref="input" step="0" :min="0" v-model="inputVat" type="number" class="form-control" placeholder="% IVA" name="vat" id = "vat" >

</div>
<button @click="$emit('close')" type="button" class="btn btn-secondary mr-3 mt-2">ANNULLA</button>
<button  type="submit" class="btn btn-primary mt-2">
          <i class="fas fa-check mr-2" aria-hidden="true"></i>
          MODIFICA
</button>

</form>
</div>


</template>

<script>


  export default {
    props:['vat'],
     components: {},
    data () {
      return {

        inputVat : 0

      }
    },

     directives: 
    {
      focus: {
      // directive definition
      inserted: function (el) 
      {
       
          el.focus() 
       

        
      }
      }
    },
    mounted()
    {
      
     this.inputVat = this.vat

      
    
    },
    created () 
    {
     
    
     
    },
    methods: 
    {
    
    
      setVat()
      {
        console.log(this.inputVat)
        this.$emit('update',this.inputVat)
      }


    }
  }
</script>
<style scoped>


</style>
